import { Button, IconButton, Typography } from "@suraasa/placebo-ui"
import { OfferLetterType } from "api/resources/offerLetter/types"
import { AuthManager } from "features/Authentication/AuthManager"
import { Xmark } from "iconoir-react"

import { getPgCTLProdDetails } from "./helpers"

const GetStartedStep = ({
  goToNextPage,
  handleClose,
  isMini,
  offerLetter,
}: {
  goToNextPage: () => void
  handleClose: () => void
  isMini: boolean
  offerLetter: OfferLetterType
}) => {
  const user = AuthManager.getPlatformAuth()?.user
  const pgctlType = getPgCTLProdDetails(offerLetter.product.slug)

  if (isMini) {
    return (
      <div className="h-full text-white">
        <div className="relative flex h-full flex-col justify-between bg-[#0B0F18] p-3 text-center sm:bg-white">
          <div>
            <div className="relative h-[185px] w-full ">
              {pgctlType && (
                <img
                  src={pgctlType.badge.mobile}
                  alt={offerLetter.product.slug}
                  className="absolute inset-x-0 -top-3 mx-auto h-[256px] w-[200px] object-contain object-center"
                  loading="eager"
                />
              )}
            </div>
            <IconButton
              onClick={handleClose}
              className="absolute right-3 top-3 text-white hover:text-onSurface-800"
            >
              <Xmark />
            </IconButton>
            <Typography
              variant="title2"
              className="relative  z-1 mb-1.5 text-[32px] font-bold leading-[100%] tracking-[-2%]"
            >
              Your PgCTL Journey Starts Here!
            </Typography>

            <Typography
              variant="body"
              className="relative z-1 mb-5 text-onSurface-500"
            >
              Congratulations,{" "}
              <span className="text-strong">{user?.firstName}!</span> You’ve
              successfully registered for the{" "}
              {pgctlType ? pgctlType.text : "PgCTL"} program. Let’s take a quick
              look at what’s ahead.
            </Typography>
          </div>
          <Button
            onClick={goToNextPage}
            className="w-full bg-white text-onSurface-900"
            autoFocus
          >
            See What&apos;s Next
          </Button>
        </div>
      </div>
    )
  }
  return (
    <div className="flex flex-col">
      <div className="relative h-[240px] w-full rounded-t-2xl  bg-[#0B0F18] sm:h-[300px]">
        {pgctlType && (
          <img
            src={pgctlType.badge.web}
            alt={offerLetter.product.slug}
            className="mx-auto size-full object-contain object-center"
          />
        )}
        <IconButton
          onClick={handleClose}
          className="absolute right-3 top-3 text-white hover:text-onSurface-800"
        >
          <Xmark />
        </IconButton>
      </div>
      <div className="rounded-b-2xl bg-[#0B0F18] p-3 text-center sm:bg-white">
        <Typography variant="title2" className="mb-1.5">
          Your PgCTL Journey Starts Here!
        </Typography>
        {user && (
          <Typography variant="body" className="mb-5 text-onSurface-500">
            Congratulations,{" "}
            <span className="text-strong">{user.firstName}!</span> You’ve
            successfully registered for the{" "}
            {pgctlType ? pgctlType.text : "PgCTL"} program. Let’s take a quick
            look at what’s ahead.
          </Typography>
        )}
        <Button
          onClick={goToNextPage}
          className="mx-auto flex"
          color="black"
          autoFocus
        >
          See What&apos;s Next
        </Button>
      </div>
    </div>
  )
}

export default GetStartedStep
